export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["SUSPENDED"] = "SUSPENDED";
    UserStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    UserStatus["KYC_PROCESSING"] = "KYC_PROCESSING";
    UserStatus["MANUAL_REVIEW"] = "MANUAL_REVIEW";
    UserStatus["DELETION_PENDING"] = "DELETION_PENDING";
})(UserStatus || (UserStatus = {}));
export var UserTitle;
(function (UserTitle) {
    UserTitle["MR"] = "MR";
    UserTitle["MS"] = "MS";
    UserTitle["MX"] = "MX";
})(UserTitle || (UserTitle = {}));
export const TRADEVEST_PROGRESS_STATUSES = [
    'not_started',
    'kyc_required',
    'natural_person_created',
    'customer_created',
    'documents_signing_pending',
    'documents_signed',
    'onboarding_initiated',
    'onboarding_approved',
    'products_created',
    'awaiting_products_activation',
    'completed',
];
export const TRADEVEST_FAILED_STATUSES = [
    'tax_id_required',
    'natural_person_creation_failed',
    'identity_verification_failed',
    'bank_account_validation_error',
    'natural_person_not_found_for_customer',
    'customer_id_extraction_failed',
    'customer_creation_failed',
    'terms_signing_failed',
    'privacy_signing_failed',
    'documents_signing_failed',
    'onboarding_creation_failed',
    'onboarding_rejected',
    'onboarding_invalid',
    'onboarding_timeout',
    'product_creation_failed',
    'products_activation_timeout',
    'unknown_error',
];
export const TRADEVEST_PROVISIONING_STATUSES = [...TRADEVEST_PROGRESS_STATUSES, ...TRADEVEST_FAILED_STATUSES];
const TRADEVEST_FAILED_STATUS_SET = new Set(TRADEVEST_FAILED_STATUSES);
export function isTradevestFailedStatus(status) {
    if (!status)
        return false;
    return TRADEVEST_FAILED_STATUS_SET.has(status);
}
const TRADEVEST_PROVISIONING_STATUS_SET = new Set(TRADEVEST_PROVISIONING_STATUSES);
export function isTradevestProvisioningStatus(status) {
    if (!status)
        return false;
    return TRADEVEST_PROVISIONING_STATUS_SET.has(status);
}
export const TRADEVEST_BUCKETS = ['NOT_STARTED', 'MIDFLIGHT', 'ERROR', 'COMPLETE'];
const TRADEVEST_BUCKET_SET = new Set(TRADEVEST_BUCKETS);
export function isTradevestBucket(value) {
    return TRADEVEST_BUCKET_SET.has(value);
}
export const TRADEVEST_STATUS_TO_BUCKET = {
    not_started: 'NOT_STARTED',
    kyc_required: 'NOT_STARTED',
    natural_person_created: 'MIDFLIGHT',
    customer_created: 'MIDFLIGHT',
    documents_signing_pending: 'MIDFLIGHT',
    documents_signed: 'MIDFLIGHT',
    onboarding_initiated: 'MIDFLIGHT',
    onboarding_approved: 'MIDFLIGHT',
    products_created: 'MIDFLIGHT',
    awaiting_products_activation: 'MIDFLIGHT',
    completed: 'COMPLETE',
    tax_id_required: 'ERROR',
    natural_person_creation_failed: 'ERROR',
    identity_verification_failed: 'ERROR',
    bank_account_validation_error: 'ERROR',
    natural_person_not_found_for_customer: 'ERROR',
    customer_id_extraction_failed: 'ERROR',
    customer_creation_failed: 'ERROR',
    terms_signing_failed: 'ERROR',
    privacy_signing_failed: 'ERROR',
    documents_signing_failed: 'ERROR',
    onboarding_creation_failed: 'ERROR',
    onboarding_rejected: 'ERROR',
    onboarding_invalid: 'ERROR',
    onboarding_timeout: 'ERROR',
    product_creation_failed: 'ERROR',
    products_activation_timeout: 'ERROR',
    unknown_error: 'ERROR',
};
export const TRADEVEST_BUCKET_TO_STATUSES = TRADEVEST_BUCKETS.reduce((acc, bucket) => {
    acc[bucket] = [];
    return acc;
}, {});
for (const status of TRADEVEST_PROVISIONING_STATUSES) {
    TRADEVEST_BUCKET_TO_STATUSES[TRADEVEST_STATUS_TO_BUCKET[status]].push(status);
}
export function getTradevestBucket(status) {
    if (!status)
        return 'NOT_STARTED';
    return TRADEVEST_STATUS_TO_BUCKET[status] ?? 'ERROR';
}
export var OTPType;
(function (OTPType) {
    OTPType["LOGIN"] = "LOGIN";
    OTPType["TRANSACTION"] = "TRANSACTION";
    OTPType["ACCOUNT_RECOVERY"] = "ACCOUNT_RECOVERY";
    OTPType["PHONE_VERIFICATION"] = "PHONE_VERIFICATION";
    OTPType["STAFF_LOGIN"] = "STAFF_LOGIN";
    OTPType["PIN_RESET"] = "PIN_RESET";
})(OTPType || (OTPType = {}));
export var OTPStatus;
(function (OTPStatus) {
    OTPStatus["PENDING"] = "PENDING";
    OTPStatus["VERIFIED"] = "VERIFIED";
    OTPStatus["EXPIRED"] = "EXPIRED";
    OTPStatus["FAILED"] = "FAILED";
})(OTPStatus || (OTPStatus = {}));
//# sourceMappingURL=user.types.js.map